import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
// @ts-expect-error dependency missing types
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { resourceUrlsMap } from '../utils/urls/resourceUrlsMap';
import { jsx as _jsx } from "react/jsx-runtime";
const ResourceLinks = ({
  upgradeConfig
}) => {
  const mappedUrls = resourceUrlsMap[upgradeConfig.upgradeKey];
  if (!mappedUrls) return null;
  const resources = Object.keys(mappedUrls);
  return /*#__PURE__*/_jsx(UIList, {
    className: "text-left",
    firstChildClassName: "m-bottom-4",
    children: resources.map(resource => {
      const url = mappedUrls[resource];
      if (resource === 'knowledgeBase') {
        return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: url,
          onClick: () => {
            getUsageTracker().track('upgradesInteraction', {
              action: `clicked knowledge base link in suite interstitial`
            });
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `pricingPage.pages.suiteStarter.${resource}`
          })
        }, resource);
      } else {
        return /*#__PURE__*/_jsx(UILink, {
          external: true,
          href: url,
          onClick: () => {
            getUsageTracker().track('upgradesInteraction', Object.assign({
              action: `clicked academy link in suite interstitial`
            }, upgradeConfig, {
              recommendationResponse: JSON.stringify(upgradeConfig.recommendationResponse)
            }));
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `pricingPage.pages.suiteStarter.${resource}`
          })
        }, resource);
      }
    })
  });
};
export default ResourceLinks;